import { CheckboxRenderProps } from 'react-aria-components';
import styles from './Checkbox.module.css';
import { NotAffectingLineHeightObject } from '../not-affecting-line-height-object';
import { FocusRing } from '../focus-ring';

export function CheckboxCheckmark({
  isFocusVisible,
  isIndeterminate,
  isDisabled,
  isSelected,
  isInvalid,
}: CheckboxRenderProps) {
  return (
    <NotAffectingLineHeightObject>
      <FocusRing isFocusVisible={isFocusVisible}>
        <div
          className={styles.checkbox}
          data-indeterminate={isIndeterminate ? 'true' : undefined}
          data-disabled={isDisabled ? 'true' : undefined}
          data-selected={isSelected ? 'true' : undefined}
          data-invalid={isInvalid ? 'true' : undefined}
        >
          <svg viewBox="0 0 18 18" aria-hidden="true" className={styles.checkmark}>
            {isIndeterminate ? (
              <rect x={2} y={7.5} width={14} height={3} />
            ) : (
              <path d="M7.6 13.2L14.65 6.15L13.25 4.75L7.6 10.4L4.75 7.55L3.35 8.95L7.6 13.2Z" />
            )}
          </svg>
        </div>
      </FocusRing>
    </NotAffectingLineHeightObject>
  );
}
